import UserError from './UserError.js'

export class ValidatePhoneVerificationCodeUserError extends UserError {}
